import React, { FC } from 'react';
import { MUIFieldProps } from '../../../../../lib/types/types';
import { Box, FormHelperText, Stack, Typography } from '@mui/material';
import { get } from 'lodash';

import 'devextreme/dist/css/dx.light.css';
import HtmlEditor, { Toolbar, Item } from 'devextreme-react/html-editor';
import deMessages from 'devextreme/localization/messages/de.json';
import { locale, loadMessages } from 'devextreme/localization';

loadMessages(deMessages);
locale(navigator.language);

const TextEditorField: FC<MUIFieldProps> = (props) => {
	const { label, fieldValue, updateFieldValue, isDisabled, error, errorMessage, ...restProps } = props;

	const handleContentChange = (e: any) => {
		let event = { target: { value: get(e, 'value') } };
		updateFieldValue(event as React.ChangeEvent<HTMLInputElement>);
	};

	return (
		<>
			<Stack>
				<Typography>{label}</Typography>
				<Box
					className="widget-container"
					style={{
						backgroundColor: '#fff',
						borderRadius: '4px',
						borderWidth: '2px !important',
						border: error ? '2px solid #d32f2f' : '2px solid transparent !important',
					}}
				>
					<HtmlEditor
						height={'25rem'}
						defaultValue={fieldValue}
						onValueChanged={handleContentChange}
						placeholder={get(restProps, 'placeholder')}
					>
						<Toolbar>
							<Item name="undo" />
							<Item name="redo" />
							<Item name="separator" />
							<Item name="size" acceptedValues={['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt']} />
							<Item name="separator" />
							<Item name="bold" />
							<Item name="italic" />
							<Item name="strike" />
							<Item name="underline" />
							<Item name="separator" />
							<Item name="alignLeft" />
							<Item name="alignCenter" />
							<Item name="alignRight" />
							<Item name="alignJustify" />
							<Item name="separator" />
						</Toolbar>
					</HtmlEditor>
					{error && <FormHelperText error>{errorMessage}</FormHelperText>}
				</Box>
			</Stack>
		</>
	);
};

export default TextEditorField;
